import React from 'react';
import ReactDOM from 'react-dom';
import ErrorModal from '../components/ErrorModal.tsx';

const API_KEY = process.env.REACT_APP_USER_API_KEY || '3a5yGEWuLumpGAMDyAvIiCw9AIF74sQs';
const SECRET_KEY = process.env.REACT_APP_USER_SECRET_KEY || 'Bf0INefVBJDx7gIOQmftTsu7OndOSRgY';


export const signRequest = async () => {
  const timestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds
  const dataToSign = `${API_KEY}:${timestamp}`;

  const encoder = new TextEncoder();
  const keyData = encoder.encode(SECRET_KEY);
  const messageData = encoder.encode(dataToSign);

  const cryptoKey = await window.crypto.subtle.importKey(
    'raw',
    keyData,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );

  const signature = await window.crypto.subtle.sign(
    'HMAC',
    cryptoKey,
    messageData
  );

  const signatureArray = Array.from(new Uint8Array(signature));
  const signatureHex = signatureArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return {
    'x-api-key': API_KEY,
    'x-timestamp': timestamp.toString(),
    'x-signature': signatureHex
  };
};

// Function to handle session expiration
const handleSessionExpiration = () => {
  // Create a div for the modal if it doesn't exist
  let modalRoot = document.getElementById('session-expiration-modal');
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.id = 'session-expiration-modal';
    document.body.appendChild(modalRoot);
  }

  // Render the modal
  ReactDOM.render(
    <ErrorModal
      isOpen={true}
      message="Tu sesión ha expirado, inicia sesión nuevamente."
      onClose={() => {
        // Clear localStorage
        localStorage.clear();
        // Redirect to home page
        window.location.href = '/';
      }}
    />,
    modalRoot
  );
};

export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
  let headers = { ...options.headers };

  const authHeaders = await signRequest();
  headers = {
    ...headers,
    ...authHeaders
  };

  const token = localStorage.getItem('access_token');

  if (token) {
    headers = {
      ...headers,
      'Authorization': `Bearer ${token}`
    };
  }

  const response = await fetch(url, {
    ...options,
    headers
  });

  // Check if response status is 401 (Unauthorized)
  if (response.status === 401) {
    handleSessionExpiration();
    // Return the original response so the calling code can handle it as needed
  }

  return response;
};
